import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export const routes = [
  {
    path: '/',
    name: 'index',
    meta: {
      title: '主页'
    },
    redirect: '/countseq',
    component: (resolve) => require(['../pages/index.vue'], resolve),
    children: [
      {
        path: '/dashboard',
        meta: {
          title: '工作台 (Dashboard)',
          selectedpath: '/dashboard'
        },
        component: (resolve) => require(['../pages/dashboard/dashboard.vue'], resolve)
      },
      {
        path: '/user',
        meta: {
          title: '人员管理 (User Manage)',
          selectedpath: '/user'
        },
        component: (resolve) => require(['../pages/user/list.vue'], resolve)
      },
      {
        path: '/role',
        meta: {
          title: '角色管理 (Role Manage)',
          selectedpath: '/role'
        },
        component: (resolve) => require(['../pages/role/list.vue'], resolve)
      },
      {
        path: '/dict',
        meta: {
          title: '字典管理 (Dict Manage)',
          selectedpath: '/dict'
        },
        component: (resolve) => require(['../pages/dict/list.vue'], resolve)
      },
      {
        path: '/duty',
        meta: {
          title: '岗位管理 (Duty Manage)',
          selectedpath: '/duty'
        },
        component: (resolve) => require(['../pages/duty/list.vue'], resolve)
      },
      {
        path: '/dept',
        meta: {
          title: '部门管理',
          selectedpath: '/dept'
        },
        component: (resolve) => require(['../pages/dept/list.vue'], resolve)
      },
      {
        path: '/dept/edit',
        meta: {
          title: '部门管理',
          selectedpath: '/dept'
        },
        component: (resolve) => require(['../pages/dept/edit.vue'], resolve)
      },
      {
        path: '/post',
        meta: {
          title: '岗位管理',
          selectedpath: '/post'
        },
        component: (resolve) => require(['../pages/post/list.vue'], resolve)
      },
      {
        path: '/post/edit',
        meta: {
          title: '岗位管理',
          selectedpath: '/post'
        },
        component: (resolve) => require(['../pages/post/edit.vue'], resolve)
      },
      {
        path: '/statistics',
        meta: {
          title: '统计分析 (Statistics)',
          selectedpath: '/statistics'
        },
        component: (resolve) => require(['../pages/statistics/statistics.vue'], resolve)
      },
      {
        path: '/user/edit',
        meta: {
          title: '用户管理',
          selectedpath: '/user'
        },
        component: (resolve) => require(['../pages/user/edit.vue'], resolve)
      },
      {
        path: '/client',
        meta: {
          title: '客户管理 (Client Manage)',
          selectedpath: '/client'
        },
        component: (resolve) => require(['../pages/client/list.vue'], resolve)
      },
      {
        path: '/countprocess',
        meta: {
          title: '工序管理',
          selectedpath: '/countprocess'
        },
        component: (resolve) => require(['../pages/countProcess/list.vue'], resolve)
      },
      {
        path: '/countseq',
        meta: {
          title: '扫码数据',
          selectedpath: '/countseq'
        },
        component: (resolve) => require(['../pages/countSeq/list.vue'], resolve)
      }
    ]
  },
  {
    path: '/login',
    meta: {
      title: 'home',
      notRequiresAuth: true
    },
    component: (resolve) => require(['../pages/common/login.vue'], resolve)
  },
  { path: '*', redirect: '/' }
]
const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js